import { c as _c } from "react/compiler-runtime";
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { FunnelLeadsApiInterface } from 'modules/funnels/funnel/types/funnel-leads-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
interface useFunnelLeadsProps extends SwrPaginationInterface {
  funnelId: FunnelId;
}
export function useFunnelLeads(t0) {
  const $ = _c(12);
  const {
    funnelId,
    limit,
    pagination
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== funnelId || $[2] !== limit || $[3] !== pagination || $[4] !== user) {
    t2 = () => {
      if (user && limit) {
        if (pagination.startFromId) {
          return `${FUNNELS_API}/${funnelId}/leads/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`;
        } else {
          return `${FUNNELS_API}/${funnelId}/leads/list?pagination[limit]=${limit}`;
        }
      }
      return null;
    };
    $[1] = funnelId;
    $[2] = limit;
    $[3] = pagination;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: leads
  } = useSWR(t2, fetcher);
  let t3;
  if ($[6] !== funnelId || $[7] !== user) {
    t3 = () => {
      if (user) {
        return `${FUNNELS_API}/${funnelId}/leads/count?pagination[limit]`;
      }
      return null;
    };
    $[6] = funnelId;
    $[7] = user;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data: counter
  } = useSWR(t3, baseFetcher);
  let t4;
  if ($[9] !== counter || $[10] !== leads) {
    t4 = {
      leads,
      counter
    };
    $[9] = counter;
    $[10] = leads;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}